<template>
  <div id="ps-event-main" class="bg-cover">
    <div class="title-wrapper">
      <h1 class="title-lg">
        免月租、零負擔<br />
        隨時開張，讓收入更靈活
      </h1>
      <h2 class="title-md-normal">陪你一起斜槓的收款工具</h2>
      <a
        href="https://merchant.ins.to/insto-apply/signup/"
        target="_blank"
        id="ps-click-pricing-apply-web"
      >
        <button class="action-button">立即線上申請</button>
      </a>
      <div class="downloads">
        <div class="app-logo bg-contain"></div>
        <a
          href="https://apps.apple.com/tw/app/id1525691104"
          target="_blank"
          rel="noopener"
          id="ps-main-iosbtn"
        >
          <div class="ios-logo bg-contain"></div>
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.insto.instotap"
          target="_blank"
          rel="noopener"
          id="ps-main-androidbtn"
        >
          <div class="android-logo bg-contain"></div>
        </a>
      </div>
      <h3 class="title-xs">
        INSTO Tap App 目前僅適用安裝於 iOS12（含）以上或<br />
        Android 9（含）以上版本的智慧型手機
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    download() {
      const modal = document.getElementById("ps-event-modal");
      modal.classList.add("show");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/main.scss";
@import "@/assets/sass/personal-slashie.scss";

#ps-event-main {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-image: url("../../assets/imgs/event/personal-slashie/bg-1920.jpg");
  height: 540px;
  margin-top: 72px;
  padding: 50px 200px;

  @media screen and (max-width: 1512px) {
    background-image: url("../../assets/imgs/event/personal-slashie/bg-1512.jpg");
    padding: 50px 250px;
  }

  @media screen and (max-width: 1024px) {
    margin-top: 60px;
    padding: 50px 50px;
  }

  @media screen and (max-width: 768px) {
    height: 540px;
    background-image: url("../../assets/imgs/event/personal-slashie/bg-768.jpg");
    padding: 50px 30px;

    .title-lg {
      font-size: 36px;
    }
  }

  @media screen and (max-width: 515px) {
    background-image: url("../../assets/imgs/event/personal-slashie/bg-390.jpg");
    height: 750px;
  }

  @media screen and (max-width: 414px) {
    background-image: url("../../assets/imgs/event/personal-slashie/bg-390.jpg");
    height: 750px;
    padding-bottom: 0;
  }
}

.title-wrapper {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 1024px;

  h2 {
    margin-bottom: 30px;
  }

  @media screen and (max-width: 1512px) {
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    margin-top: 150px;
  }

  @media screen and (max-width: 515px) {
    margin-top: 400px;

    h1.title-lg {
      font-size: 30px !important;
      line-height: 1.2 !important;
      margin-bottom: 12px;
    }

    h2.title-md-normal {
      font-size: 24px !important;
      margin-bottom: 20px;
    }

    .title-xs {
      font-size: 13px !important;
    }
  }
}

.downloads {
  margin-bottom: 20px;
}

.app-logo {
  background-image: url("../../assets/imgs/app-logo.png");
}

.android-logo {
  background-image: url("../../assets/imgs/download-google-play.png");
}

.ios-logo {
  background-image: url("../../assets/imgs/download-app-store.png");
}
</style>
